import React from 'react';

function Summary({ data }) {
  const cards = [
    { label: 'ページビュー', value: data.totalPageviews, color: '#58a6ff' },
    { label: 'ユニーク訪問者', value: data.uniqueVisitors, color: '#bc8cff' },
    { label: 'セッション数', value: data.uniqueSessions, color: '#3fb950' },
    { label: '総クリック数', value: data.totalClicks, color: '#f0883e' },
    { label: '平均スクロール深度', value: `${data.avgScrollDepth}%`, color: '#f85149' },
  ];

  return (
    <div className="summary">
      {cards.map((card, i) => (
        <div className="summary-card" key={i}>
          <span className="value" style={{ color: card.color }}>{card.value}</span>
          <span className="label">{card.label}</span>
        </div>
      ))}
    </div>
  );
}

export default Summary;
